import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DatePicker from "./smartComponents/datePicker";
import PreviousDatePicker from "./smartComponents/previousDatePicker";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/sagas/multiLocation/multiLocation";
import FilterLevelFirstSelect from "./smartComponents/filterLevelFirstSelect";
import FilterLevelSecondSelect from "./smartComponents/filterLevelSecondSelect";
import FilterLevelThirdSelect from "./smartComponents/filterLevelThirdSelect";
import FilterLevelFourSelect from "./smartComponents/filterLevelFourSelect";
import GroupBy from "./smartComponents/groupBy";
import RevenueTable from "./smartComponents/revenueTable";
import ConversionsTable from "./smartComponents/conversionsTable";
import CustomDateRanges from "./smartComponents/customDateRanges";

import styles from "./multiLocation.module.css";

const ActionSection = ({ moveToNextRow, render }) => {
  if (moveToNextRow) {
    return <div className={styles.actionButtons}>{render()}</div>;
  }

  return render();
};

ActionSection.propTypes = {
  moveToNextRow: PropTypes.bool,
  render: PropTypes.func.isRequired
};

export class MultiLocationModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersDirty: false
    };
  }

  resetData = () => {
    this.props.fetchTableData(this.props.userParams);
    this.setState({
      filtersDirty: false
    });
  };

  componentDidMount() {
    this.initFetchData();
  }

  initFetchData = () => {
    this.props.fetchTableData(this.props.userParams);
  };

  canRenderUpdateButton = () => {
    if (
      this.props.filtersDirty &
      !this.props.isLoading &
      // (this.props.selectedLevelFirst.length > 0) &
      // (this.props.selectedLevelSecond.length > 0) &
      // (this.props.selectedLevelThird.length > 0) &
      // (this.props.selectedLevelFourth.length > 0) &
      (this.props.selectedRequestDates.startDate !== "Invalid date") &
      (this.props.selectedRequestDates.endDate !== "Invalid date")
    ) {
      return true;
    }
  };

  renderTables = () => {
    const { membership_revenue_mom_total, revenue_mom_total } = this.props.allRevenue;
    let membershipMoMTotalClass, revenueMoMTotalClass;

    if (membership_revenue_mom_total && membership_revenue_mom_total.indexOf("-") > -1) {
      membershipMoMTotalClass = "negative";
    } else {
      membershipMoMTotalClass = "positive";
    }

    if (revenue_mom_total && revenue_mom_total.indexOf("-") > -1) {
      revenueMoMTotalClass = "negative";
    } else {
      revenueMoMTotalClass = "positive";
    }

    return (
      <div className="multilocation-sections">
        <section className={styles.sectionTable}>
          <div className="table-wrapper-top">
            <div className="table-top total-revenue">
              <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
                <div className="title">
                  <h2>{this.props.allRevenue.titles[0]}</h2>
                </div>
                <div className="metrics" style={{ width: "45%" }}>
                  <p>{this.props.allRevenue.titles[1]}</p>
                  <div className="sub-metrics">
                    <p className="total">
                      <span>
                        <span>{this.props.allRevenue.revenue_total}</span>
                        {this.props.allRevenue.revenue_mom_total !== "0.0%" ? (
                          <span className={`percent ${revenueMoMTotalClass}`}>
                            {this.props.allRevenue.revenue_mom_total}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Previous: <span>{this.props.allRevenue.revenue_lm_total}</span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Average: <span>{this.props.allRevenue.revenue_total_average}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-top membership-revenue">
              <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
                <div className="title">
                  <h2>{this.props.allRevenue.titles[2]}</h2>
                  <p>&nbsp;</p>
                </div>
                <div className="metrics" style={{ width: "45%" }}>
                  <p>{this.props.allRevenue.titles[3]}</p>
                  <div className="sub-metrics">
                    <p className="total">
                      <span>
                        <span>{this.props.allRevenue.membership_revenue_total}</span>
                        {this.props.allRevenue.membership_revenue_mom_total !== "0.0%" ? (
                          <span className={`percent ${membershipMoMTotalClass}`}>
                            {this.props.allRevenue.membership_revenue_mom_total}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Previous:&nbsp;
                      <span>{this.props.allRevenue.membership_revenue_lm_total}</span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Average:&nbsp;
                      <span>{this.props.allRevenue.membership_revenue_total_average}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="table-wrapper revenue-table">
            <RevenueTable />
          </div>
        </section>

        <section className={styles.sectionTable}>
          <div className="table-wrapper-bottom">
            <div className="table-top leads-added">
              <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
                <div className="title">
                  <h2>{this.props.conversions.titles[0]}</h2>
                </div>
                <div className="metrics" style={{ width: "45%" }}>
                  <p>{this.props.conversions.titles[1]}</p>
                  <div className="sub-metrics">
                    <p className="total">
                      <span>
                        <span>{this.props.conversions.leads_total}</span>
                        {this.props.conversions.leads_mom_total !== "0.0%" ? (
                          <span
                            className={`percent ${
                              this.props.conversions.leads_mom_total.indexOf("-") > -1
                                ? "negative"
                                : "positive"
                            }`}
                          >
                            {this.props.conversions.leads_mom_total}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Previous: <span>{this.props.conversions.leads_lm_total}</span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Average: <span>{this.props.conversions.leads_total_average}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-top appointment">
              <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
                <div className="title">
                  <h2>{this.props.conversions.titles[2]}</h2>
                  <p>{this.props.conversions.titles[3]}</p>
                </div>
                <div className="metrics" style={{ width: "45%" }}>
                  <p>{this.props.conversions.titles[4]}</p>
                  <div className="sub-metrics">
                    <p className="total">
                      <span>
                        <span>{this.props.conversions.app_total}</span>
                        {this.props.conversions.app_mom_total !== "0.0%" ? (
                          <span
                            className={`percent ${
                              this.props.conversions.app_mom_total.indexOf("-") > -1
                                ? "negative"
                                : "positive"
                            }`}
                          >
                            {this.props.conversions.app_mom_total}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Previous:&nbsp;<span>{this.props.conversions.app_lm_total}</span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Average:&nbsp;<span>{this.props.conversions.app_total_average}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-top show">
              <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
                <div className="title">
                  <h2>{this.props.conversions.titles[5]}</h2>
                  <p>{this.props.conversions.titles[6]}</p>
                </div>
                <div className="metrics" style={{ width: "45%" }}>
                  <p>{this.props.conversions.titles[7]}</p>
                  <div className="sub-metrics">
                    <p className="total">
                      <span>
                        <span>{this.props.conversions.show_total}</span>
                        {this.props.conversions.show_mom_total !== "0.0%" ? (
                          <span
                            className={`percent ${
                              this.props.conversions.show_mom_total.indexOf("-") > -1
                                ? "negative"
                                : "positive"
                            }`}
                          >
                            {this.props.conversions.show_mom_total}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Previous:&nbsp;<span>{this.props.conversions.show_lm_total}</span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Average:&nbsp;<span>{this.props.conversions.show_total_average}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-top enrollment">
              <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
                <div className="title">
                  <h2>{this.props.conversions.titles[8]}</h2>
                  <p>{this.props.conversions.titles[9]}</p>
                </div>
                <div className="metrics" style={{ width: "45%" }}>
                  <p>{this.props.conversions.titles[10]}</p>
                  <div className="sub-metrics">
                    <p className="total">
                      <span>
                        <span>{this.props.conversions.enroll_total}</span>
                        {this.props.conversions.enroll_mom_total !== "0.0%" ? (
                          <span
                            className={`percent ${
                              this.props.conversions.enroll_mom_total.indexOf("-") > -1
                                ? "negative"
                                : "positive"
                            }`}
                          >
                            {this.props.conversions.enroll_mom_total}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Previous:&nbsp;<span>{this.props.conversions.enroll_lm_total}</span>
                    </p>
                  </div>
                  <div className="sub-metrics">
                    <p>
                      Average:&nbsp;<span>{this.props.conversions.enroll_total_average}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="table-wrapper conversion-table">
            <ConversionsTable />
          </div>
        </section>
      </div>
    );
  };

  content() {
    if (this.props.isLoading) {
      return null;
    }

    const supportsFirstSelect =
      this.props.availableFilters.filter_levels !== undefined &&
      this.props.availableFilters.filter_levels.includes("level_1");
    const moveActionButtonsToNextRow = supportsFirstSelect && this.props.isGroupBySupported;

    return (
      <>
        {!this.props.filtersLoading && !this.props.isLoading && (
          <div
            className={`edit-selections-bar ${styles.editSelectionsBar} `}
            style={{ height: "220px" }}
          >
            <div className={styles.datesContainer}>
              <div className="select-box" style={{ width: 344 }}>
                <p className="offers-title">Date Range</p>
                {!this.state.filtersDirty && <CustomDateRanges />}
              </div>
              <div className="date-select-box multi" style={{ width: 302 }}>
                <p>Date</p>
                {!this.state.filtersDirty && <DatePicker />}
              </div>
              {this.props.selectedRequestPrevDates?.prevStartDate ? (
                <div className="date-select-box multi" style={{ width: 317 }}>
                  <p>Previous</p>
                  <PreviousDatePicker />
                </div>
              ) : null}
            </div>
            <div className={styles.filtersContainer}>
              {supportsFirstSelect && (
                <div className="select-box" style={{ width: 200 }}>
                  <p>{this.props.availableFilters.filter_titles[0]}</p>
                  <FilterLevelFirstSelect />
                </div>
              )}
              <div className="select-box" style={{ width: 200 }}>
                <p>{this.props.availableFilters.filter_titles[1]}</p>
                {!this.props.secondLevelFiltersLoading ? (
                  <FilterLevelSecondSelect />
                ) : (
                  <LoadingAnimation uiLoader />
                )}
              </div>
              <div className="select-box" style={{ width: 200 }}>
                <p>{this.props.availableFilters.filter_titles[2]}</p>
                {!this.props.thirdLevelFiltersLoading ? (
                  <FilterLevelThirdSelect />
                ) : (
                  <LoadingAnimation uiLoader />
                )}
              </div>
              <div className="select-box" style={{ width: 200 }}>
                <p>{this.props.availableFilters.filter_titles[3]}</p>
                {!this.props.fourthLevelFiltersLoading ? (
                  <FilterLevelFourSelect />
                ) : (
                  <LoadingAnimation uiLoader />
                )}
              </div>
              {this.props.isGroupBySupported && (
                <div className="select-box" style={{ width: 200 }}>
                  <p>{this.props.groupByLabel}</p>
                  <GroupBy />
                </div>
              )}

              <div className={styles.actionButtons}>
                <ActionSection
                  moveToNextRow={moveActionButtonsToNextRow}
                  render={() => (
                    <>
                      {this.canRenderUpdateButton() && (
                        <button
                          className={`submit ${moveActionButtonsToNextRow && styles.submitButton}`}
                          onClick={this.props.updateTables}
                        >
                          Update
                        </button>
                      )}
                      {this.props.filtersDirty && !this.props.isLoading && (
                        <button
                          className={`submit reset ${
                            moveActionButtonsToNextRow && styles.resetButton
                          }`}
                          onClick={this.initFetchData}
                        >
                          Reset
                        </button>
                      )}
                    </>
                  )}
                />
              </div>
            </div>
          </div>
        )}
        {this.props.tablesLoading ? (
          <LoadingAnimation text="Updating tables..." />
        ) : (
          this.renderTables()
        )}
      </>
    );
  }

  render() {
    return (
      <div className="multi-location-module universal">
        <SectionToggle
          autoHeight
          title="Universal"
          customClass="multi-location-comparison"
          isLoading={this.props.isLoading}
          hideToggle
          content={this.content()}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.multiLocation.isLoading,
    filtersDirty: state.multiLocation.filtersDirty,
    selectedRequestDates: state.multiLocation.selectedRequestDates,
    filterTitles: state.multiLocation.filterTitles,
    filterLevels: state.multiLocation.filterLevels,
    selectedLevelFirst: state.multiLocation.selectedLevelFirst,
    selectedLevelSecond: state.multiLocation.selectedLevelSecond,
    selectedLevelThird: state.multiLocation.selectedLevelThird,
    selectedLevelFourth: state.multiLocation.selectedLevelFourth,
    tablesLoading: state.multiLocation.tablesLoading,
    conversions: state.multiLocation.conversions,
    conversionsData: state.multiLocation.conversions.tableInfo.data,
    allRevenue: state.multiLocation.allRevenue,
    allRevenueData: state.multiLocation.allRevenue.tableInfo.data,
    filtersLoading: state.multiLocation.filtersLoading,
    secondLevelFiltersLoading: state.multiLocation.secondLevelFiltersLoading,
    thirdLevelFiltersLoading: state.multiLocation.thirdLevelFiltersLoading,
    fourthLevelFiltersLoading: state.multiLocation.fourthLevelFiltersLoading,
    availableFilters: state.multiLocation.availableFilters,
    isGroupBySupported: state.multiLocation.groupBy.display,
    groupByLabel: state.multiLocation.groupBy.label,
    selectedRequestPrevDates: state.multiLocation.selectedRequestPrevDates
  }),
  {
    fetchTableData: actionCreators.fetchTableData,
    updateTables: actionCreators.requestNewTableData
  }
)(MultiLocationModule);

MultiLocationModule.propTypes = {
  fetchTableData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  tablesLoading: PropTypes.bool,
  userParams: PropTypes.object,
  filtersDirty: PropTypes.bool,
  selectedRequestDates: PropTypes.object,
  updateTables: PropTypes.func,
  filterTitles: PropTypes.array,
  filterLevels: PropTypes.array,
  selectedLevelFirst: PropTypes.any,
  selectedLevelSecond: PropTypes.any,
  selectedLevelThird: PropTypes.any,
  selectedLevelFourth: PropTypes.any,
  filtersLoading: PropTypes.bool,
  secondLevelFiltersLoading: PropTypes.bool,
  thirdLevelFiltersLoading: PropTypes.bool,
  fourthLevelFiltersLoading: PropTypes.bool,
  allRevenue: PropTypes.object,
  allRevenueData: PropTypes.array,
  conversions: PropTypes.object,
  conversionsData: PropTypes.array,
  availableFilters: PropTypes.object,
  isGroupBySupported: PropTypes.bool.isRequired,
  groupByLabel: PropTypes.string.isRequired,
  selectedRequestPrevDates: PropTypes.object
};
